// import { useMemo } from 'react';

//! *** Component Props Hook ****

export const useStateProps = (props) => {
    const hasStateChanges = props.states.hasChanges;
    const onStateChanges = (hasChanges) => { props.states.onChanges(hasChanges); };

    const isQueuing = props.states.isQueuing;
    const adviseDownload = props.states.adviseDownload;
    const adviseQueuing = props.states.adviseQueuing;


    return { hasStateChanges ,onStateChanges ,isQueuing ,adviseDownload ,adviseQueuing };
};

export const useImageProps = (props) => {
    const noImage = !props.image.url;
    const hasImage = !!props.image.url;

    const imageUrl = props.image.url;
    const imageSource = props.image.source;

    const imageInfoHeader = props.image.info?.header || '';
    const imageName = props.image.info?.name || '';
    const imageWidth = props.image.info?.width || 0;
    const imageHeight = props.image.info?.height || 0;

    const onImageUpload = props.image.onUpload;

    //! NB if using memoization
    // const imageWidth = useMemo(() => image.info.width, [image.info.width]);
    // const imageHeight = useMemo(() => image.info.height, [image.info.height]);

    return { noImage ,hasImage ,imageUrl ,imageSource ,imageInfoHeader ,imageName ,imageWidth ,imageHeight ,onImageUpload };
};

export const useFormatProps = (props) => {
    const formatName = props.format.name;
    const formatSelect = props.format.onSelect;

    return { formatName ,formatSelect };
};
